import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * 見積:サイズ選択オプション
 */
export const yhc_kazai_type_size_options: ModelDef = {
  tableName: 'yhc_kazai_type_size_options',
  tableLabel: '見積:サイズ選択オプション',
  primaryKeyColType: 'NUMBER',
  columns: {
    kazai: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '家財',
      replicable: true,
      visible: false,
      relationshipManyToOne: {
        collectionName: 'yhc_kazai_types',
        labelFormatter: (row) => `${row.name} (${row.admin_title})`,
      },
    },
    name: {
      type: 'STRING',
      label: 'サイズ名称',
      replicable: true,
      inputHelpText: '例: "一人用"',
      validate: { notEmpty: true },
    },
    thumb: {
      type: 'FILE',
      label: 'サムネイル画像',
      replicable: true,
      inputHelpText: '設定しない場合は、家財のデフォルト画像が利用されます',
      inputAttrs: { wrapperStyle: { maxWidth: '200px' } },
    },
    size_h: {
      type: 'NUMBER',
      label: '高さ(cm)',
      replicable: true,
      validate: { notEmpty: true },
      inputAttrs: { wrapperStyle: { maxWidth: '100px' } },
    },
    size_w: {
      type: 'NUMBER',
      label: '幅(cm)',
      replicable: true,
      validate: { notEmpty: true },
      inputAttrs: { wrapperStyle: { maxWidth: '100px' } },
    },
    size_d: {
      type: 'STRING',
      label: '奥行(cm)',
      replicable: true,
      validate: { notEmpty: true },
      inputAttrs: { wrapperStyle: { maxWidth: '100px' } },
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      replicable: true,
      validate: { notEmpty: true },
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      replicable: true,
      validate: { notEmpty: true },
    },
    isEnabledOnDebug: {
      type: 'BOOLEAN',
      label: '開発用プレビューで表示',
      replicable: true,
    },
  },
}
